import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.160167,1083.13128 C867.881444,1083.13128 792.786424,1008.03626 792.786424,915.757541 C792.786424,823.478817 867.881444,748.383797 960.160167,748.383797 C1052.43889,748.383797 1127.53391,823.478817 1127.53391,915.757541 C1127.53391,1008.03626 1052.43889,1083.13128 960.160167,1083.13128 L960.160167,1083.13128 Z M960.160167,0 L28,932.048585 L107.000407,1011.04899 L234.873947,883.063869 L234.873947,1920 L792.786424,1920 L792.786424,1362.08752 L1127.53391,1362.08752 L1127.53391,1920 L1685.44639,1920 L1685.44639,883.063869 L1813.31993,1011.04899 L1892.32033,932.048585 L960.160167,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHomeSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconHomeSolid, _Component);

  var _super = _createSuper(IconHomeSolid);

  function IconHomeSolid() {
    _classCallCheck(this, IconHomeSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconHomeSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHome",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHomeSolid.displayName = "IconHomeSolid";
  return IconHomeSolid;
}(Component);

IconHomeSolid.glyphName = 'home';
IconHomeSolid.variant = 'Solid';
IconHomeSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHomeSolid;
export { IconHomeSolid };